module.exports = __webpack_public_path__ + "static/media/Team 33 - Vikings_Voyage.1d9c203c.png";